import React, { useState, useEffect } from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import Tritech_2 from "../../../assets/images/Tritech_2.svg"

import "./benefits-product-special.scss"

const BenefitsProductSpecial = ({ params, mobile, haveShopSecret, flujoType }) => {
  const isEC = process.env.LOCALE === "es-EC"
  const isCL = process.env.LOCALE === "es-CL"
  const isBO = process.env.LOCALE === "es-BO"
  const urlPantiesAbsorbentes = "https://www.nosotrasonline.com.ec/magazin/nuestro-mundo/panties-absorbentes-y-reutilizables-para-el-periodo-intimawear-de-nosotras-ecuador/"

  const urlVideo = () => {
    switch (process.env.LOCALE) {
      case "es-CL":
        return "https://www.youtube.com/embed/mfMaADDce64"
      default:
        return "https://www.youtube.com/embed/PA-fMYeXMXQ"
    }
  }

  const benefits = [
    {
      id: 1,
      description: (
        <p>
          Al usarlos <b>ayudas a cuidar el planeta</b> pues generan 90% menos
          residuos y tienen 82% menos impacto en el medio ambiente.
        </p>
      ),
    },
    {
      id: 2,
      description: (
        <p>
          Aunque tienen varias capas{" "}
          {isEC && (
            <a
              target="_blank"
              href={urlPantiesAbsorbentes}
            >
              absorbentes
            </a>
          )}
           {!isEC && "absorbentes"}, no se notan por debajo de tu ropa pues están hechos con{" "}
          <b>poliéster</b>, un material que ofrece mayor absorción que el
          algodón y que te permitirá seguir usando tu ropa preferida.
        </p>
      ),
    },
    {
      id: 3,
      description: process.env.LOCALE !== "es-CL" && (
        <p>
          Están disponibles en{" "}
          <a
            target="_blank"
            href={
              isEC
                ? "https://www.tiendanosotras.com.ec/"
                : "https://www.tiendanosotras.com/"
            }
          >
            Tiendanosotras.com
          </a>
          , un portal súper completo donde además podrás encontrar
          acompañamiento para escoger los Íntima Wear perfectos para ti.
        </p>
      ),
    },
  ]

  if (!haveShopSecret) benefits.pop()

  return (
    <section className={`f-benefits-section-product-special `}>
      <div className="f-background-container">
        <div className="f-section-container">
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title={
              mobile ? "¡Sus beneficios!" : "¡Sus beneficios son increíbles!"
            }
          />
        </div>

        <div className="f-section-container">
          <div className="f-left-section">
            <p className="f-text-description-title ">
              {isCL ? (
                <>
                  Conoce algunos de los beneficios de utilizar el Calzón
                  Reutilizable Íntimawear de Nosotras
                </>
              ) : (
                <>
                  Conoce algunos de los beneficios de usar{" "}
                  {isBO
                    ? "la ropa interior"
                    : "los Panty"}{" "}
                  Íntima Wear de Nosotras
                </>
              )}
            </p>
            <div className="f-description-container">
              <ul>
                {benefits.map(benefit => (
                  <li key={benefit.id}>{benefit.description}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="f-right-section">
            <div className="f-video-container">
              <iframe
                src={urlVideo()}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="f-section-container">
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title={` Además, ${
              isBO
                ? " Íntima Wear está diseñados"
                : isCL
                ? "el Calzón Reutilizable está diseñado"
                : "están los panties diseñados"
            } con una revolucionaria tecnología inteligente:`}
          />
        </div>
        <div className="f-section-container">
          <div className="f-left-section">
            <p className="f-text-description-title ">
              {isBO
                ? "La ropa interior Íntima Wear de Nosotras cuenta con"
                : isCL
                ? "El Calzón Reutilizable Íntimawear de Nosotras cuenta con"
                : "El panty Íntima Wear de Nosotras cuenta con"}{" "}
              tecnología Tritech, para que ahora, vivas la libertad de no sentir
              nada y estar protegida gracias a sus tres capas especiales:
            </p>
            <div className="f-description-container">
              <ul>
                <li>
                  La primera es suave, absorbe el flujo con rápidez y aleja la
                  humedad del cuerpo, para que te sientas seca todo el tiempo.
                </li>
                <li>
                  La segunda capa, además de ser absorbente, también retiene el
                  flujo <b>y controla los olores {flujoType === 'Moderado' ? 'de 8 a 10' : 'por 12'} horas .</b>
                </li>
                <li>
                  Y la tercera es respirable, para mayor frescura y comodidad.
                </li>
              </ul>
            </div>
          </div>
          <div className="f-right-section">
            <img src={Tritech_2} alt="tritech performance" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default BenefitsProductSpecial
